<template>
  <div class="tw-flex tw-h-full tw-flex-col tw-font-inter">
    <Header v-if="!isEmbedded" />

    <Loader />

    <FlashMessages />
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Header from './Blocks/Header.vue';

const isEmbedded = computed(() => window.self !== window.top);
</script>
